module.exports = __webpack_public_path__ + "img/eyes.0024507a.svg";